import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { DatosPersonales } from 'src/app/global/interfaces/datos-personales';
import { Nacionalidad } from 'src/app/global/interfaces/nacionalidad';
import { datosPersonales } from 'src/app/messages/step-2-messages';
import { correoValidator } from 'src/app/view-model/validators/correo.validator';

import { MatExpansionPanel } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { AUTH_INDICATOR } from 'src/app/global/enums/auth-indicator.enum';
import { DatosPersonalesRequest } from 'src/app/global/interfaces/datos-personales-request';
import { Ejecutivo } from 'src/app/global/interfaces/ejecutivo';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { ProductosProvider } from 'src/app/global/providers/services/productos/productos.provider';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { DatosPersonalesService } from 'src/app/global/services/datos-personales.service';
import { FlujosPaso2Service } from 'src/app/global/services/flujos-paso-2.service';
import { InputErrorService } from 'src/app/global/services/input-errors.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { SessionService } from 'src/app/global/services/session.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { step1Messages } from 'src/app/messages/step-1-messages';
import { DialogServiceProvider } from 'src/app/view-model/providers/services/dialog/dialog.provider';
import { AuthVMService } from 'src/app/view-model/services/auth-vm.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';
import { lengthValidator } from 'src/app/view-model/validators/max-length.validator';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-datos-personales-ci',
  templateUrl: './datos-personales-ci.component.html',
  styleUrls: ['./datos-personales-ci.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogServiceProvider, ProductosProvider]
})
export class DatosPersonalesCiComponent {

  isMarketplaceSVA = false;
  ejecutivo: Ejecutivo;

  get flujo() {
    return this.flujosPaso2Serv.datosPersonales;
  }

  constructor(
    private datosPersonalesService: DatosPersonalesService,
    private dialogService: DialogService,
    private marketplaceRedirectService: MarketplaceRedirectService,
    private storage: LocalStorageService,
    private productService: vmProductosService,
    private tagM: TagManagerService,
    private flujosPaso2Serv: FlujosPaso2Service,
    private inputErrorService: InputErrorService,
    private authVmService: AuthVMService,
    private rutFormatter: RutFormatterService,
    private route: ActivatedRoute,
    private sessionService: SessionService
  ) { }


  async ngOnInit(): Promise<void> {
    this.getEjecutivo();
    this.isMarketplaceSVA = String(this.route.snapshot.queryParams.msva).toLowerCase() === 'true';
  }

  getEjecutivo() {
    this.ejecutivo = this.sessionService.ejecutivo != null ? this.sessionService.ejecutivo : this.sessionService.getEjecutivo();
    if (this.ejecutivo) {
      if (this.sessionService.ejecutivo != null) {
        this.datosCiForm.patchValue({
          txtEjecutivo: this.sessionService.ejecutivo.id
        });
      }
    }
  }

  get calculaCantidadALlenar() {
    let cantidad = 2;
    const nombre = _.get(this.datosPersonalesResponse, 'nombre', null);
    const apellido1 = _.get(this.datosPersonalesResponse, 'apellidoPaterno', null);
    const nacionalidad = _.get(this.datosPersonalesResponse, 'idNacionalidad', null);
    cantidad += nombre === '' ? 1 : 0;
    cantidad += apellido1 === '' ? 1 : 0;
    cantidad += nacionalidad !== 47 ? 1 : 0;
    if (!this.isDatosPrecargados) {
      cantidad = 5;
    }
    return cantidad;
  }

  get rutControl(): FormControl {
    return this.datosCiForm.get('txtRut') as FormControl;
  }

  get serieControl(): FormControl {
    return this.datosCiForm.get('txtSerie') as FormControl;
  }

  get ejecutivoControl(): FormControl {
    return this.datosCiForm.get("txtEjecutivo") as FormControl;
  }

  get authControl(): FormControl {
    return this.datosCiForm.get('autorizacion') as FormControl;
  }
  get authControl2(): FormControl {
    return this.datosCiForm.get('autorizacion2') as FormControl;
  }

  @ViewChild(MatExpansionPanel, { static: false }) matExpansion: MatExpansionPanel;

  isDatosPrecargados = false;
  datosPersonalesResponse: DatosPersonales;
  nacionalidades: Nacionalidad[] = [];
  edicion = true;
  processing = false;
  clickTimeout = null;
  urlTerminos = environment.redirections.urlTerminos;
  urlPrivacidad = environment.redirections.urlPrivacidad;


  // datos localstorage paso1
  rut: String = this.storage.getPaso1Login().run.toString();
  correo: String = this.storage.getPaso1Login().correo;
  telefono: String = this.storage.getPaso1Login().telefono.toString();

  // datos form valida ci
  formRut = 0;
  formRutControl: number;
  formSerieControl: string;
  respuestaAuthCI: GeneralResponse<any>;

  // control de panles
  ready = false;
  loading = false;
  dialog2doPlano = false;
  ciValidado = false;

  @Input() showInfoMessage: boolean;

  @Input() showCantidadCampos = true;

  @Output() paso1Ok: EventEmitter<any> = new EventEmitter();

  public datosCiForm: FormGroup = this.authVmService.createForm();

  public datosPersonalesForm: FormGroup = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    primerApellido: new FormControl('', [Validators.required]),
    segundoApellido: new FormControl('', [Validators.nullValidator]),
    nacionalidad: new FormControl('0', [Validators.required, Validators.min(1)]),
    correoElectronico: new FormControl('', [Validators.required, correoValidator]),
    telefono: new FormControl('', [Validators.required, lengthValidator(9, 9), Validators.pattern('^[1-9][0-9]*')])
  });

  public mensajeErrorDatosPersonales = datosPersonales;

  public messageRescatarDataError = {
    txtSerie: [
      { type: 'required', message: step1Messages.REQUIRED_SERIE_MESSAGE },
      { type: 'serieLength', message: step1Messages.INVALID_SERIE_MESSAGE },
      { type: 'invalidSerieOfRut', message: step1Messages.INVALID_SERIE_OF_RUT }
    ],
    txtRut: [
      { type: 'required', message: step1Messages.REQUIRED_RUT_MESSAGE },
      { type: 'dniInvalid', message: step1Messages.INVALID_RUT_MESSAGE }
    ]
  };

  formChanged = false;

  init(requiereValidacion?: string): void {
    this.ciValidado = !requiereValidacion;
    this.ciValidado = false;
    if (this.ciValidado) {
      this.validaEdicion();
    }
  }

  checkInputCI(campo: string) {
    this.inputErrorService.validarError('P1', this.datosCiForm.get(campo));
  }

  checkInput(campo: string) {
    this.inputErrorService.validarError('P2', this.datosPersonalesForm.get(campo));
  }

  modalCiHelper(): void {
    const dialogRef = this.dialogService.openCiViewerDialog();
    dialogRef.afterClosed().subscribe();
  }

  error(error, callback: Function) {
    if (error.error.indicador === 'PROCESO_SEGUNDO_PLANO') {
      this.dialogService.openEnSegundoProcesoDialog();
    } else {
      this.showErrorDialog(error.statusText, error.message, () => callback());
    }
  }

  Validar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.onSubmitValidate();
      }, 100);
    }
  }

  async validaCi(form: FormGroup): Promise<GeneralResponse<any>> {
    if (!form.valid) {
      throw new Error('form invalid');
    }

    const formDocumentControl = form.get('txtSerie');
    const formRut = form.get('txtRut').value;
    const rutInformation = this.rutFormatter.getRutFormats(formRut);
    const documentNumber = (formDocumentControl.value as string).replace(/\./g, '');
    const idEjecutivo: number = form.get('txtEjecutivo').value;
    this.formRut = rutInformation.numbers;
    this.formRutControl = this.formRut;
    this.formSerieControl = String(formDocumentControl.value).toUpperCase();

    const response: GeneralResponse<any> = await this.datosPersonalesService.validaCi(rutInformation.numbers, documentNumber, idEjecutivo, this.isMarketplaceSVA).toPromise();
    this.respuestaAuthCI = response;
    if (response === null) {
      throw new Error('auth error');
    }
    if (response.indicador) {
      const loginAttemptsControl = form.get('intentos');
      loginAttemptsControl.setValue(loginAttemptsControl.value + 1);
      switch (response.indicador) {
        case AUTH_INDICATOR.UNFINISHED_TRIP_BEFORE_42_DAYS: {
          this.authVmService.unfinishedTripBefore42DaysDialog();
          return;
        }
        case AUTH_INDICATOR.INTENTOS_AGOTADOS: {
          this.authVmService.bloquedAccountDialog(form);
          return;
        }
        case AUTH_INDICATOR.ERROR: {
          const intentosAgotados = response.mensaje.contenido.includes('se le han agotado los intentos');
          if (intentosAgotados) {
            this.authVmService.bloquedAccountDialog(form);
          } else {
            this.authVmService.validarContenido(response, form);
          }
          return;
        }
      } // fin switch
      this.ciValidado = true;
      return response;
    } // fin if
  }

  async onSubmitValidate(): Promise<void> {
    let authResponse = null;
    let respuesta = null;
    try {
      this.loading = true;
      this.tagM.logEvent(GoogleTagManager.eventInteracciones().categriaDatosPersonales().setIsPersonaNatural(true))
      authResponse = await this.validaCi(this.datosCiForm);
      // response handle
      if (_.get(authResponse, 'indicador', '') === 'OK') {
        this.processing = false;
        this.validaEdicion();
      }
    } catch (exception) {
      const loginAttemptsControl = this.datosCiForm.get('intentos');
      loginAttemptsControl.setValue(loginAttemptsControl.value + 1);

      this.tagM.logError('Paso 1', _.get(exception, 'error.mensaje.titulo', ''), _.get(exception, 'error.message', ''));
      if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'se le han agotado los intentos')) {
        respuesta = this.dialogService.openAccountBloquedDialog();
        respuesta.afterClosed().subscribe((resp) => {
          if (resp.action === 'OK') {
            this.marketplaceRedirectService.redirect();
          }
        });
      } else if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'NO_VIGENTE')) {

        if (this.datosCiForm.get('intentos').value === 2) {
          respuesta = this.dialogService.openInvalidSerieOfRutSecondAttemptDialog();
        } else if (this.datosCiForm.get('intentos').value === 1) {
          respuesta = this.dialogService.openInvalidSerieOfRutFirstAttemptDialog();
        }
      } else if (_.includes(_.get(exception, 'error.indicador'), 'INTENTOS_AGOTADOS')) {
        respuesta = this.dialogService.openAccountBloquedDialog();
        respuesta.afterClosed().subscribe((resp) => {
          if (resp.action === 'OK') {
            this.marketplaceRedirectService.redirect();
          }
        });
      } else {
        console.error(exception);
        respuesta = this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, intenta más tarde.');
        respuesta.afterClosed().subscribe((resp) => {
          if (resp.action === 'OK') {
            return;
          }
        });
      }
    } finally {
      this.loading = false;
      this.processing = false;
    }
  }

  validaEdicion() {
    this.edicion = true;
    this.getNacionalidades();
  }

  getNacionalidades(): void {
    const fnSuccess = (nacionalidades: Nacionalidad[]) => {
      this.nacionalidades = nacionalidades;
      this.getDatosPersonales();
    };
    const fnFailure = (error) => {
      console.error(error);
      this.error(error, () => this.getNacionalidades());
      this.tagM.logError('Paso 2', error.statusText, error.message);
    };
    this.datosPersonalesService.getNacionalidades().subscribe(fnSuccess, fnFailure);
  }

  functionNr1(): void {
    setTimeout(() => {
      this.getDatosPersonales();
    }, 5000);
  }

  getDatosPersonales(): void {
    const fnSuccess = (resp) => {
      if (resp != null) {
        if (_.get(resp, 'indicador', '') === 'PROCESO_SEGUNDO_PLANO') {
          this.dialogService.openEnSegundoProcesoDialog();
          if (!this.dialog2doPlano) {
            let gevent = GoogleTagManager.eventInteracciones().categriaDatosPersonales().setAccion("view");
            this.tagM.logEvent(gevent.setEtiqueta("procesando información").setIsPersonaNatural(true));
          }
          this.dialog2doPlano = true;
          this.functionNr1();
        } else {
          if (this.dialog2doPlano == true) {
            this.dialogService.closeProcesoSegundoPlanoDialog();
            this.dialog2doPlano = false;
          }
          this.isDatosPrecargados = true;
          this.datosPersonalesResponse = resp as DatosPersonales;
          this.datosPersonalesForm.get('nombre').setValue(this.datosPersonalesResponse.nombre.nombres);
          this.datosPersonalesForm.get('primerApellido').setValue(this.datosPersonalesResponse.nombre.apellidoPaterno);
          this.datosPersonalesForm.get('segundoApellido').setValue(this.datosPersonalesResponse.nombre.apellidoMaterno);
          if (this.datosPersonalesResponse.idNacionalidad) {
            this.datosPersonalesForm.get('nacionalidad').setValue(this.datosPersonalesResponse.idNacionalidad);
          } else {
            this.datosPersonalesForm.get('nacionalidad').setValue(0);
          }
          if (this.datosPersonalesResponse.correo !== undefined && this.datosPersonalesResponse.correo !== '') {
            this.datosPersonalesForm.get('correoElectronico').setValue(this.datosPersonalesResponse.correo);
          } else {
            this.datosPersonalesForm.get('correoElectronico').setValue(this.correo);
            this.isDatosPrecargados = false;
          }
          if (this.datosPersonalesResponse.telefono !== undefined && this.datosPersonalesResponse.telefono !== 0) {
            this.datosPersonalesForm.get('telefono').setValue(this.datosPersonalesResponse.telefono);
          } else {
            this.datosPersonalesForm.get('telefono').setValue(this.telefono);
            this.isDatosPrecargados = false;
          }
          if (this.datosPersonalesForm.valid && (!this.isDatosPrecargados || this.storage.getPaso1Login().retoma == "")) {
            this.guardar();
          } else if (this.datosPersonalesForm.valid && this.isDatosPrecargados) {
            const datos: DatosPersonalesRequest = {
              nombres: this.datosPersonalesResponse.nombre,
              idNacionalidad: this.datosPersonalesResponse.idNacionalidad,
              correo: this.datosPersonalesResponse.correo,
              telefono: this.datosPersonalesResponse.telefono
            };
            this.storage.setPaso2({ datosPersonales: datos });
            this.flujosPaso2Serv.datosPersonales.ok = true;
            this.flujosPaso2Serv.datosComercio.bloqueado = false;
            this.flujosPaso2Serv.datosComercio.cargando = true;
            this.paso1Ok.emit();
          } else {
            this.matExpansion.open();
            this.dialogService.closeProcesoSegundoPlanoDialog();
          }
        }
      } else {
        this.isDatosPrecargados = false;
        this.matExpansion.open();
        this.dialogService.closeProcesoSegundoPlanoDialog();
      }
      this.flujosPaso2Serv.datosPersonales.mostrar = true;
      this.flujosPaso2Serv.datosPersonales.cargando = false;
    };

    const fnFailure = error => {
      // console.error(error);
      // this.showErrorDialog(error.statusText, error.message, () => this.getDatosPersonales());
      this.error(error, () => this.getDatosPersonales());
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.functionNr1();
    };

    // Obtener el rut desde el paso 1 (puede ser por un @Input)
    // Obtiene los datos luego de la validación
    this.datosPersonalesService.getDatosPersonales().subscribe(fnSuccess, fnFailure);
  }

  Continuar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.registraDatos();
      }, 100);
    }
  }

  guardar(): void {
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.registraDatos();
      }, 100);
    }
  }

  registraSeleccionProducto() {
    try {
      this.productService.registraSeleccionProductoActual().toPromise();
    } catch (e) {
      console.error('SELECCION PRODUCTO:', e);
    }
  }

  async registraDatos() {
    this.loading = true;
    const datos: DatosPersonalesRequest = {
      nombres: {
        nombres: this.datosPersonalesForm.get('nombre').value,
        apellidoPaterno: this.datosPersonalesForm.get('primerApellido').value,
        apellidoMaterno: this.datosPersonalesForm.get('segundoApellido').value
      },
      idNacionalidad: Number(this.datosPersonalesForm.get('nacionalidad').value),
      correo: this.datosPersonalesForm.get('correoElectronico').value,
      telefono: Number(this.datosPersonalesForm.get('telefono').value)
    };

    const fnSuccess = async (resp) => {
      // Persona registrada
      this.registraSeleccionProducto();
      if (!this.flujosPaso2Serv.datosComercio.ok) {
        if (!this.isDatosPrecargados) {
          console.log('Llamada a datalayer OK');
        }
        this.storage.setPaso2({ datosPersonales: datos });
        this.ready = true;
        this.flujosPaso2Serv.datosPersonales.ok = true;
        this.flujosPaso2Serv.datosComercio.cargando = true;
        this.flujosPaso2Serv.datosComercio.bloqueado = false;
        this.paso1Ok.emit();
        this.tagM.logDL_datosPersonales();
      }
      this.matExpansion.close();
      this.loading = false;
      this.processing = false;
    };

    const fnFailure = (error) => {
      console.error(error);
      this.loading = false;
      this.error(error, () => this.registraDatos());
      this.tagM.logError('Paso 2', error.statusText, error.message);
      this.processing = false;
    };

    this.datosPersonalesService.registraDatosPersonales(datos).subscribe(fnSuccess, fnFailure);
  }

  showErrorDialog(title: string, message: string, callback: Function) {
    this.dialogService.openErrorDialog(title, message).afterClosed()
      .subscribe((data) => {
        callback();
      });
  }

}
